/**
 * Map of all features, where each key is the feature identifier and
 * the value is an array of REGION's where the feature is enabled.
 * @example { 'feature_name': ['US', 'UK'] }
 */
const activeFeatures = {
  cartful: ['US'],
  auto_email_marketing_opt_in: ['US']
};

/**
 * Utility for programatically handling feature flags
 */
class Feature {
  /**
   * Adds a feature to the feature map (currently only used for ease of testing)
   * @param {String} name Feature identifier
   * @param {Array} activeGroups List of active regions
   * @returns {Boolean} `true` if feature has been added, `false` otherwise.
   */
  add(name, activeGroups) {
    if (!name || !activeGroups) return false;
    if (activeFeatures[name]) return false;
    activeFeatures[name] = activeGroups;
    return true;
  }

  /**
   * Gets the state of a the provided feature (enabled/disabled).
   * @param {String} name Feature identifier
   * @returns {Boolean} `true` if feature is enabled, `false` if feature is not enabled or invalid.
   */
  isEnabled(name) {
    const activeGroups = activeFeatures[name];

    if (!activeGroups) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(
          `Unrecognized feature '${name}'. Did you spell it correctly?`
        );
      }
      return false;
    }

    return activeGroups.includes('US');
  }
}

export default new Feature();
